module.exports = __webpack_public_path__ + "img/sandbox.56800265.svg";